<template>
	<div v-loading="loading" class="base_scroll_page">
		<div class="b_scroller">
			<!-- 查询条件 -->
			<div class="base_inquire">
				<div class="b_item">
					<span class="b_label">账号：</span>
					<el-input v-model="search_account" class="b_inp" placeholder="账号"></el-input>
				</div>
				
				<div class="b_item">
					<span class="b_label">路径：</span>
					<el-input v-model="search_url" class="b_inp" placeholder="路径"></el-input>
				</div>
				
				<div class="b_item">
					<span class="b_label">开始时间：</span>
					<el-date-picker
						v-model="search_startTime"
						:editable="false"
						placeholder="开始时间"
						type="datetime"
						value-format="yyyy-MM-dd HH:mm:ss"
						@change="handleSearchStartTimeChange"
					>
					</el-date-picker>
				</div>
				
				<div class="b_item">
					<span class="b_label">结束时间：</span>
					<el-date-picker
						v-model="search_endTime"
						:editable="false"
						placeholder="结束时间"
						type="datetime"
						value-format="yyyy-MM-dd HH:mm:ss"
						@change="handleSearchEndTimeChange"
					>
					</el-date-picker>
				</div>
				
				<el-button type="primary" @click="handleSearchClick">查询</el-button>
			</div>
			<!-- 查询条件 end -->
			
			<!-- 表格 -->
			<div class="base_table" style="margin-top: 20px;">
				<el-table
					:data="tableData"
					style="width: 100%"
				>
					<el-table-column
						prop="code"
						label="账号"
					>
					</el-table-column>
					<el-table-column
						prop="url"
						label="路径"
					>
					</el-table-column>
					<el-table-column
						prop="params"
						label="请求参数"
					>
					</el-table-column>
					<el-table-column
						prop="result"
						label="返回结果"
					>
					</el-table-column>
					<el-table-column
						prop="time"
						label="时间"
					>
					</el-table-column>
				</el-table>
			</div>
			<!-- 表格 end -->
			
			<!-- 页码 -->
			<div class="clear_both" style="margin-top: 20px;">
				<div class="base_pager" style="float: right;">
					<el-pagination
						layout="total, prev, pager, next, jumper"
						next-text="下一页" 
						:total="total"
						:page-size="5"
						:current-page="currentPage"
						@current-change="handlePageChange">
					</el-pagination>
				</div>
			</div>
			<!-- 页码 end -->
		</div>
	</div>	
</template>

<script>
	import BaseMethods from '../../../../../assets/js/base.js'
	import Api from '../../../../../api/index.js'
	
	export default {
		mounted () {
			this.getList();
		},
		data () {
			return {
				loading: false,
				
				tableData: [],
				total: 0,
				currentPage: 1,
				
				search_account: '',
				search_url: '',
				search_startTime: '',
				search_endTime: ''
			}
		},
		methods: {
			/************************ @Events *******************************/
			// 切换查询时间
			handleSearchStartTimeChange() {
				this.compareSearchTime();
			},
			// 切换查询时间
			handleSearchEndTimeChange() {
				this.compareSearchTime();
			},
			// 点击查询
			handleSearchClick () {
				this.currentPage = 1;
				this.getList();
			},
			// 切换页码
			handlePageChange (page) {
				if (this.currentPage != page) {
					this.currentPage = page;
					this.getList();
				}
			},
			
			/************************ @Function *******************************/
			// 获取数据
			getList () {
				const that = this;
				that.loading = true;
				var requestData = {
					"code": that.search_account,
					"endTime": that.search_endTime,
					"id": null,
					"limit": 5,
					"logType": null,
					"pageNum": that.currentPage,
					"platformType": null,
					"serviceName": null,
					"startTime": that.search_startTime,
					"url": that.search_url
				};
				Api.findLogPrescription(requestData).then((res) => {
					that.loading = false;
					if (res.data.success) {
						that.total = res.data.data.totalItems;
						that.tableData = [];
						for (var i = 0;i < res.data.data.data.length;i++) {
							var _o = res.data.data.data[i];
							that.tableData.push({
								id: _o.id,
								code: _o.optUserCode || '',
								url: _o.optUrl || '',
								params: _o.questionParams || '',
								result: _o.resultDetail || '',
								time: BaseMethods.formatTime(_o.createTime, 'yy-mm-dd hh:mm:ss')
							});
						}
					} else {
						that.$message.error(res.data.message);
					}
				}, (e) => {
					that.loading = false;
					that.$message.error(e.message);
				});
			},
			// 比较开始时间和结束时间
			compareSearchTime () {
				if (this.search_startTime && this.search_endTime) {
					var startTime = new Date(this.search_startTime).getTime(),
						endTime = new Date(this.search_endTime).getTime();
					if (endTime < startTime) {
						this.search_endTime = '';
						this.$message.warning('结束时间不能小于开始时间');
					}
				}
			}
		}
	}
</script>

<style scoped>
</style>
